import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { burlingtonVtConfig } from "./data";

export default function BurlingtonVtPage() {
  return <CityPageTemplate config={burlingtonVtConfig} />;
}